export default {
  CHI_SIAMO: "page_chi_siamo",
  COSA_OFFRIAMO: "page_cosa_offriamo",
  CHIRURGO_REGISTER: "page_chirurgo_register",
  PRIVACY_POLICY:"page_privacy_policy"
}
